export default __webpack_public_path__ + "static/media/img-series-a.c1719d5b.png";